import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import * as coreHttpCompat from "@azure/core-http-compat";
import { ServiceImpl, ContainerImpl, BlobImpl, PageBlobImpl, AppendBlobImpl, BlockBlobImpl } from "./operations";
export var StorageClient = /*#__PURE__*/function (_coreHttpCompat$Exten) {
  _inherits(StorageClient, _coreHttpCompat$Exten);

  var _super = _createSuper(StorageClient);

  /**
   * Initializes a new instance of the StorageClient class.
   * @param url The URL of the service account, container, or blob that is the target of the desired
   *            operation.
   * @param options The parameter options
   */
  function StorageClient(url, options) {
    var _this;

    _classCallCheck(this, StorageClient);

    var _a, _b;

    if (url === undefined) {
      throw new Error("'url' cannot be null");
    } // Initializing default values for options


    if (!options) {
      options = {};
    }

    var defaults = {
      requestContentType: "application/json; charset=utf-8"
    };
    var packageDetails = "azsdk-js-azure-storage-blob/12.25.0";
    var userAgentPrefix = options.userAgentOptions && options.userAgentOptions.userAgentPrefix ? "".concat(options.userAgentOptions.userAgentPrefix, " ").concat(packageDetails) : "".concat(packageDetails);
    var optionsWithDefaults = Object.assign(Object.assign(Object.assign({}, defaults), options), {
      userAgentOptions: {
        userAgentPrefix: userAgentPrefix
      },
      endpoint: (_b = (_a = options.endpoint) !== null && _a !== void 0 ? _a : options.baseUri) !== null && _b !== void 0 ? _b : "{url}"
    });
    _this = _super.call(this, optionsWithDefaults); // Parameter assignments

    _this.url = url; // Assigning values to Constant parameters

    _this.version = options.version || "2024-11-04";
    _this.service = new ServiceImpl(_assertThisInitialized(_this));
    _this.container = new ContainerImpl(_assertThisInitialized(_this));
    _this.blob = new BlobImpl(_assertThisInitialized(_this));
    _this.pageBlob = new PageBlobImpl(_assertThisInitialized(_this));
    _this.appendBlob = new AppendBlobImpl(_assertThisInitialized(_this));
    _this.blockBlob = new BlockBlobImpl(_assertThisInitialized(_this));
    return _this;
  }

  return StorageClient;
}(coreHttpCompat.ExtendedServiceClient);